import script from "./PgsSavings.vue?vue&type=script&setup=true&lang=ts"
export * from "./PgsSavings.vue?vue&type=script&setup=true&lang=ts"

import "./PgsSavings.vue?vue&type=style&index=0&id=466b5dd2&lang=scss"

const __exports__ = script;

export default __exports__